import React, { FC, ReactNode } from 'react';
import { Box } from '@material-ui/core';
import { useIconColor } from '../../hooks/useIconColor';
import { useDefaultShopStyles } from '../../hooks/useDefaultShopStyles';

interface IconWithCountProps {
  icon: ReactNode;
  count?: number;
  isTransparentTopbar?: boolean;
}

const IconWithCount: FC<IconWithCountProps> = (props: IconWithCountProps) => {
  const { icon, count, isTransparentTopbar } = props;

  const { iconColor } = useIconColor();
  const { shopColor00 } = useDefaultShopStyles();

  return (
    <Box display="flex" alignItems="center" position="relative">
      {icon}
      {/* Use a static font here instead of brand's fonts */}
      <b
        style={{
          backgroundColor: isTransparentTopbar ? undefined : iconColor,
          border: isTransparentTopbar ? '1px solid #fff' : undefined,
          color: shopColor00,
          fontSize: '8px',
          fontFamily: 'Poppins, sans-serif',
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          borderRadius: '50%',
          width: '16px',
          height: '16px',
          // lineheight manually inspected
          lineHeight: isTransparentTopbar ? '15px' : '17px',
        }}
      >
        {count}
      </b>
    </Box>
  );
};

export default IconWithCount;
